// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/layout/Secondary.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/layout/Secondary.tsx");
  import.meta.hot.lastModified = "1732036225883.2302";
}
// REMIX HMR END

import React from "react";
import PageHeader from "~/components/field/PageHeader";
import { AuthorCard, ContentWrapper, CTA } from "~/components";
import { BlogTeaser } from "../views";
import SocialShare from "../static/SocialShare";
import { ParagraphViewReference } from "../paragraph";
export default function Secondary({
  node,
  children
}) {
  const publishedDate = {
    dateTime: node.created?.time,
    readable: new Date(node.created?.time).toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    })
  };
  return <article>
            {node.title && <PageHeader title={node.title}>
                    <div className="self-center mt-4 w-fit text-base font-semibold divide-x-2">
                        <address className="inline not-italic pr-2">
                            By{" "}
                            <span className="text-neutral-300" rel="author">
                                {node.author?.fullName}
                            </span>
                        </address>
                        <time dateTime={publishedDate.dateTime} className="pl-2">
                            {publishedDate.readable}
                        </time>
                    </div>
                </PageHeader>}
            <ContentWrapper className="bg-white" Item="div" spacing="secondary">
                <BlogTeaser item={node} variant="blog" />
            </ContentWrapper>
            <main>
                {children}
            </main>
            <ContentWrapper className="bg-white" spacing="secondary">
                <AuthorCard picture={node.author?.picture} name={node.author?.fullName} bio={node.author?.bio} jobTitle={node.author?.jobTitle} />
            </ContentWrapper>
            <ContentWrapper className="bg-white" spacing="secondary">
                <SocialShare alignment="primary" />
            </ContentWrapper>
            <ContentWrapper className="bg-white" spacing="secondary">
                <ParagraphViewReference variant="secondary" display={node.relatedBlogs.display} items={node.relatedBlogs.results} titleOptional={"Related Blogs"} />
            </ContentWrapper>
            <ContentWrapper className="bg-neutral-100" spacing="primary">
                <CTA {...node.cta} />
            </ContentWrapper>
        </article>;
}
_c = Secondary;
var _c;
$RefreshReg$(_c, "Secondary");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;